import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from './config/api';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import FAQPage from './pages/FAQPage';
import SchedulePage from './pages/SchedulePage';
import ScoreboardPage from './pages/ScoreboardPage';
import ResultsPage from './pages/ResultsPage';
import RankingsPage from './pages/RankingsPage';
import TeamsPage from './pages/TeamsPage';
import NewsPage from './pages/NewsPage';
import MediaPage from './pages/MediaPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import Season2Page from './pages/Season2Page';
import '@/App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    axios.post(`${API}/seed`).catch(() => {});
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/cookies" element={<CookiesPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/schedule" element={<SchedulePage />} />
                <Route path="/scoreboard" element={<ScoreboardPage />} />
                <Route path="/results" element={<ResultsPage />} />
                <Route path="/rankings" element={<RankingsPage />} />
                <Route path="/teams" element={<TeamsPage />} />
                <Route path="/season2/schedule" element={<SchedulePage season={2} />} />
                <Route path="/season2/scoreboard" element={<Season2Page section="scoreboard" />} />
                <Route path="/season2/results" element={<Season2Page section="results" />} />
                <Route path="/season2/rankings" element={<Season2Page section="rankings" />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/media" element={<MediaPage />} />
                <Route path="/gallery" element={<MediaPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
